import { useState, useCallback } from 'react';
import { AudioItem } from '@/components/ui/audio-player';

interface UseAudioPlayerReturn {
    audios: AudioItem[];
    isVisible: boolean;
    setAudios: (audios: AudioItem[]) => void;
    showPlayer: () => void;
    hidePlayer: () => void;
    closePlayer: () => void;
    openSettings: () => void;
}

export function useAudioPlayer(): UseAudioPlayerReturn {
    const [audios, setAudios] = useState<AudioItem[]>([]);
    const [isVisible, setIsVisible] = useState(false);

    const showPlayer = useCallback(() => {
        setIsVisible(true);
    }, []);

    const hidePlayer = useCallback(() => {
        setIsVisible(false);
    }, []);

    const closePlayer = useCallback(() => {
        setIsVisible(false);
        setAudios([]);
    }, []);

    const openSettings = useCallback(() => {
        // Handle settings logic here
        console.log('Audio player settings opened');
    }, []);

    return {
        audios,
        isVisible,
        setAudios,
        showPlayer,
        hidePlayer,
        closePlayer,
        openSettings,
    };
} 